"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classcat = _interopRequireDefault(require("classcat"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _InputError = _interopRequireDefault(require("./InputError"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const Item = _styledComponents.default.li.withConfig({
  displayName: "RadioButtons__Item",
  componentId: "okqurg-0"
})(["display:flex;align-items:center;justify-content:center;height:48px;padding:0 16px;box-shadow:inset 0 0 0 1px ", ";cursor:pointer;color:#555;font-size:14px;", ";&:not(:last-of-type){margin-right:8px;}&:hover{box-shadow:inset 0 0 0 1px ", ";color:#333;}&.selected{box-shadow:inset 0 0 0 4px ", ";color:#333;}"], p => p.err ? p.theme.colors.err : '#a9a9a9', p => p.theme.transition, p => p.theme.colors.main, p => p.theme.colors.main);

class RadioButtons extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      selected: ''
    });

    _defineProperty(this, "select", value => () => {
      const {
        onChange
      } = this.props;
      this.setState(() => ({
        selected: value
      }));
      onChange(value);
    });
  }

  componentDidMount() {
    const {
      select
    } = this.props;
    this.select(select)();
  }

  componentDidUpdate(prevProps) {
    const {
      select = ''
    } = this.props;

    if (select !== prevProps.select) {
      this.select(select)();
    }
  }

  render() {
    const {
      className,
      items,
      label,
      err
    } = this.props;
    const {
      selected
    } = this.state;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: className
    }, label && /*#__PURE__*/_react.default.createElement("label", null, label), /*#__PURE__*/_react.default.createElement("ul", null, items.map(item => /*#__PURE__*/_react.default.createElement(Item, {
      className: (0, _classcat.default)({
        selected: item.value === selected
      }),
      key: item.value,
      err: err,
      onClick: this.select(item.value)
    }, item.text))), err && /*#__PURE__*/_react.default.createElement(_InputError.default, null, err));
  }

}

RadioButtons.propTypes = {
  label: _propTypes.default.string,
  items: _propTypes.default.arrayOf(_propTypes.default.shape({})).isRequired,
  select: _propTypes.default.string,
  onChange: _propTypes.default.func.isRequired
};
RadioButtons.defaultProps = {
  label: '',
  select: ''
};

var _default = (0, _styledComponents.default)(RadioButtons).withConfig({
  displayName: "RadioButtons",
  componentId: "okqurg-1"
})(["margin-bottom:24px;label{display:block;margin-bottom:8px;}ul{display:flex;}"]);

exports.default = _default;